import { React } from "react";
import { Row, Col, Input, Label } from "reactstrap";
import AddonCounter from "./AddOnCounter";

const AddonsSection = ({ addonLabels, selectedItem, setSelectedItem }) => {
  const handleCheckBoxChange = (e, label) => {
    const isChecked = e.target.checked;

    setSelectedItem((prev) => {
      let updatedAddons = [...prev.addons];

      if (isChecked) {
        updatedAddons.push({
          id: label.id,
          name: label.name,
          price: Number(label.price),
          quantity: 1,
        });
      } else {
        updatedAddons = updatedAddons.filter((addon) => addon.id !== label.id);
      }

      const addonsTotal = updatedAddons.reduce(
        (sum, addon) => sum + addon.price * addon.quantity,
        0
      );

      return {
        ...prev,
        addons: updatedAddons,
        totalPrice: prev.price * prev.quantity + addonsTotal,
      };
    });
  };

  const handleAddonQuantityChange = (label, newQuantity) => {
    setSelectedItem((prev) => {
      const updatedAddons = prev.addons
        .map((addon) =>
          addon.id === label.id ? { ...addon, quantity: newQuantity } : addon
        )
        .filter((addon) => addon.quantity > 0);

      const addonsTotal = updatedAddons.reduce(
        (sum, addon) => sum + addon.price * addon.quantity,
        0
      );

      return {
        ...prev,
        addons: updatedAddons,
        totalPrice: prev.price * prev.quantity + addonsTotal,
      };
    });
  };

  return (
    <div className="mt-4 mx-2 px-0">
      <Row className="justify-content-between align-items-center mb-0">
        <Col xs={8}>
          <h4
            style={{ fontWeight: "600" }}
            className="fs--18 mb-0 normal-heading"
          >
            Select your Add-ons
          </h4>
        </Col>
        <Col xs={4} className="d-flex justify-content-end">
          <h4 className="text-danger fs--15 fw--600 mb-0">Optional</h4>
        </Col>
      </Row>

      <div className="add-ons-container py-1">
        {addonLabels.length > 0 &&
          addonLabels.map((label, index) => {
            const isSelected = selectedItem.addons.some(
              (item) => item.id === label.id
            );
            const selectedAddon = selectedItem.addons.find(
              (item) => item.id === label.id
            );
            const quantity = (selectedAddon && selectedAddon?.quantity) || 1;

            return (
              <Row
                key={`addon-${label.id}-${index}`}
                className="py-2 mx-2 border-bottom"
              >
                <Col
                  className="d-flex justify-content-between align-items-center px-0"
                  style={{ color: "rgb(57, 63, 66)", fontSize: "14px" }}
                >
                  <div className="d-flex flex-row align-items-center">
                    <Input
                      type="checkbox"
                      id={`addon-${index}`}
                      name="addons"
                      checked={isSelected}
                      onChange={(e) => handleCheckBoxChange(e, label)}
                      className="form-check-input timing-modal-checkbox ml-0 my-0 py-0"
                    />
                    <Label
                      check
                      htmlFor={`addon-${index}`}
                      className="text-capitalize normal-heading ml-2"
                    >
                      {label.name}
                    </Label>
                  </div>

                  <div className="d-flex align-items-center">
                    {isSelected && (
                      <AddonCounter
                        quantity={quantity}
                        onChange={(newQuantity) =>
                          handleAddonQuantityChange(label, newQuantity)
                        }
                      />
                    )}
                    <span className="ml-3 normal-heading">
                      {label.price
                        ? `${selectedItem?.currency || "$"}${(
                            label.price * quantity
                          ).toFixed(2)}`
                        : "-"}
                    </span>
                  </div>
                </Col>
              </Row>
            );
          })}
      </div>
    </div>
  );
};

export default AddonsSection;
